export const CS_ADMIN_ROUTE = {
  name: 'csadmin',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',

  CREATE_SO: {
    name: 'createso',
    route(): string[] {
      return [...CS_ADMIN_ROUTE.route(), this.name];
    }
  },
  DASHBOARD: {
    name: 'dashboard',
    route(): string[] {
      return [...CS_ADMIN_ROUTE.route(), this.name];
    },

    DISTRICT: {
      name: 'district',
      route(): string[] {
        return [...CS_ADMIN_ROUTE.DASHBOARD.route(), 'district'];
      },
      BOARD: {
        name: ':boardId',
        route(boardId: string): string[] {
          return [...CS_ADMIN_ROUTE.DASHBOARD.DISTRICT.route(), boardId];
        }
      }
    },
    OVERALL_PRODUCT: {
      name: 'overallproduct',
      route(): string[] {
        return [...CS_ADMIN_ROUTE.DASHBOARD.route(), this.name];
      }
    }
  },
  DISTRICT: {
    name: 'district/:boardId',
    route(boardId: string): string[] {
      return [...CS_ADMIN_ROUTE.route(), 'district', boardId];
    }
  }
};
